<template>
  <v-row no-gutters>
    <v-col cols="6">
      <SelectPicker
        v-model="newStartTime"
        subtitle="Début *"
        :items="computedStartTime"
        :rules="mandatoryRule"
        :have-error="haveError"
        :isdisable="editable"
      />
    </v-col>
    <v-col cols="6">
      <SelectPicker
        v-model="newEndTime"
        subtitle="Fin *"
        :items="computedEndTime"
        :rules="mandatoryRule"
        :have-error="haveError"
        :isdisable="editable"
      />
    </v-col>
  </v-row>
</template>

<script>
import { computed, watch, ref, inject } from '@vue/composition-api';
import { fromUnixTime, getUnixTime, format } from 'date-fns';
import { mandatoryRule } from '@/helpers/utils';
import { startTimeOptions, endTimeOptions } from '@/helpers/dataManager';
import { isEndTimeAllowedToCreate } from '@/helpers/sessions';

import SelectPicker from '@/components/common/Form/SelectPicker.vue';

import store from '@/store';

export default {
  components: { SelectPicker },
  props: {
    startTime: {
      type: [Number, String],
      default: null
    },
    endTime: {
      type: [Number, String],
      default: null
    },
    date: { type: String, default: null },
    editable: { type: Boolean, default: false }
  },
  setup (props, { emit }) {
    const startTimeFormated = () => (props.startTime ? format(new Date(fromUnixTime(props.startTime)), 'HH:mm') : null);
    const endTimeFormated = () => (props.endTime ? format(new Date(fromUnixTime(props.endTime)), 'HH:mm') : null);

    const newStartTime = ref(startTimeFormated());
    const newEndTime = ref(endTimeFormated());

    const computedStartTime = computed(() => startTimeOptions());
    const computedEndTime = computed(() => endTimeOptions());
    const selectedDate = computed(() => (props.date ? props.date : store.getters.selectedDate));

    const formatedStart = computed(() => getUnixTime(new Date(`${selectedDate.value}T${newStartTime.value}`)));

    const formatedEnd = computed(() => getUnixTime(new Date(`${selectedDate.value}T${newEndTime.value}`)));

    const haveError = computed(() => !isEndTimeAllowedToCreate({ start_time: formatedStart.value, end_time: formatedEnd.value }, false));

    const updateTimes = () => {
      emit('update:startTime', formatedStart.value);
      emit('update:endTime', formatedEnd.value);
    };

    watch(newStartTime, () => {
      updateTimes();
    });

    watch(newEndTime, () => {
      updateTimes();
    });

    return { newStartTime, newEndTime, mandatoryRule, haveError, computedStartTime, computedEndTime };
  }
};
</script>
